import { useMStockThemeMode } from '@/hooks/useMStockThemeMode'
import mStockDarkLoading from '@assets/lottie/dark-loading.json'
import mStockLightLoading from '@assets/lottie/loading.json'
import clsx from 'clsx'
import lottie from 'lottie-web'
import { memo, useEffect, useRef } from 'react'

const LOTTIE_WIDTH = 138
const LOTTIE_HEIGHT = 33

export const MStockLoadingUI = memo(({ height, className }) => {
  const containerRef = useRef(null)
  const theme = useMStockThemeMode(containerRef)

  useEffect(() => {
    if (!containerRef.current) {
      return
    }

    const animationData = theme === 'dark' ? mStockDarkLoading : mStockLightLoading

    const animation = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: structuredClone(animationData)
    })

    return () => {
      animation.destroy()
    }
  }, [theme])

  return (
    <article
      className={clsx(
        'bg-m-surface-page flex min-h-[60px] items-center justify-center gap-16 text-center',
        className
      )}
      style={{ height: `${height}px` }}
      role="status"
      aria-label="로딩 중"
    >
      <div
        ref={containerRef}
        className="shrink-0"
        style={{
          width: LOTTIE_WIDTH,
          height: LOTTIE_HEIGHT
        }}
        aria-hidden="true"
      />
    </article>
  )
})
